import ClubTemplate from "../components/templates/ClubTemplate.jsx";
import useSeo from "../hooks/useSeo.js";
import { CLUBS } from "../content.js";

const club = CLUBS.find((c) => c.id === "katargam");

const SIGNATURE = [
  {
    title: "A Walk Through Oneiros Katargam",
    video: "/oneiros/katargam-tour.mp4",
    poster: "/oneiros/poster-kat-tour.jpg",
    ratio: "9/16",
    copy: "Take a guided tour through Surat's first of its kind sports club — the training floors, courts, pool and studios that make Katargam the city's most complete destination.",
  },
  {
    title: "Asia's Strongest Gym",
    image: "/oneiros/strongest-gym.jpg",
    copy: "A world-class high-performance gym built for serious training — advanced strength equipment, competition-grade free weights and professional coaching. Train like a champion. Perform without limits.",
  },
  {
    title: "First & Only Indoor Semi-Olympic Swimming Pool in Surat",
    image: "/oneiros/kat-pool.jpg",
    copy: "Surat's first and only indoor semi-Olympic swimming pool — international-standard swimming in a temperature-controlled, weather-independent environment, for year-round training and leisure.",
  },
  {
    title: "Kids Club — Game Identification Program",
    image: "/oneiros/kids-game-id.jpg",
    copy: "6 days, 6 activities, 6 expert coaches. Children explore Skating, Karate, Swimming, Dance, Yoga and CrossFit while we identify each child's natural interest and ability — no trial and error, no forced choices.",
  },
  {
    title: "European Style Fitness Studio",
    image: "/oneiros/european-studio.jpg",
    copy: "Where European elegance meets modern fitness — thoughtfully curated spaces, modern equipment and refined aesthetics. Fitness here feels exclusive, immersive and inspiring.",
  },
  {
    title: "Surat's First-Ever Prakash Padukone International Badminton Academy",
    video: "/oneiros/padukone.mp4",
    poster: "/oneiros/poster-badminton-academy.jpg",
    ratio: "9/16",
    copy: "A new benchmark in professional badminton training — designed to nurture talent with discipline, technique and internationally proven coaching methods.",
  },
  {
    title: "India's First-Ever Sports Club Anthem",
    video: "/oneiros/anthem-720.mp4",
    poster: "/oneiros/poster-anthem.jpg",
    ratio: "16/9",
    copy: "A landmark anthem created to represent strength, sportsmanship and unity. The official sound that defines the spirit and identity of Oneiros.",
  },
  {
    title: "350 kg of Pure Strength Training",
    video: "/oneiros/lift-300.mp4",
    poster: "/oneiros/poster-lift.jpg",
    copy: "Challenge yourself with our 350 kg tyre — designed to build explosive power, full-body strength and unmatched conditioning.",
  },
];

export default function ClubKatargam() {
  useSeo({
    title: "Oneiros Katargam | Asia's Strongest Gym & Sports Club in Surat",
    description:
      "Oneiros Katargam — Surat's first of its kind sports club. Asia's Strongest Gym, Surat's first indoor semi-Olympic swimming pool, Prakash Padukone Badminton Academy, kids club, fitness studios and more.",
    image: "/oneiros/katargam-hero.png",
  });
  return (
    <ClubTemplate
      testId="katargam"
      club={club}
      seo={null}
      heroLines={["The First Adaptation of a", "Premium Sports Club", "in Surat."]}
      heroCopy="Oneiros Katargam — a holistic sports and wellness destination crafted for modern lifestyles. One club. Every age. Every goal. Every day."
      introEyebrow="One Club"
      introLines={["One Club. Every Age.", "Every Goal.", "Every Day."]}
      introPoints={["High-Performance Gym", "Fitness Studios", "Indoor & Outdoor Sports", "Family Activity Zones", "Kids Activities", "Recovery & Lifestyle"]}
      signature={SIGNATURE}
      ctaLines={["Experience", "Katargam."]}
      trainBg="/oneiros/kat-gym.jpg"
    />
  );
}
